/* eslint-disable no-loss-of-precision */
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useEffect, useState } from "react";
import { Input, message, Button, Row, Col, Spin } from "antd";

import { capitaliseWithHyphen, capitalize, serialNum } from "../../../utils";
import { useNavigate, useParams } from "react-router-dom";
import { Empty } from "antd";

import TableContainer from "../../../components/TableContainer";
import { APIs } from "../../../utils/worker";

import { ReactComponent as Scan_check } from "../../../assests/images/SVG/check.svg";

import urls from "../../../api/urls";
import API from "../../../api";
import Heading from "../../../components/Heading";
// import mockData from "./mock.json";

const { UPDATE_CP_WISE_SORTING_STATUS, GET_CP_WISE_SORTING_DATA } = urls;

import "./style.scss";

const InScanTable = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [mainData, setMainData] = useState([]);
  const [premiseName, setPremiseName] = useState("");
  const [totalShipment, setTotalShipment] = useState({
    packets: 0,
    shipments: 0,
  });

  useEffect(() => {
    getTableData();
  }, []);

  let mock = [
    {
      toPremise: 495,
      cpName: "ALLAHABAD-CIVIL LINE-SANGAM PALACE",
      packets: [
        {
          status: "OUSCAN",
          awbNumber: 1111111111,
        },
      ],
      shipments: [
        {
          status: "OUSCAN",
          awbNumber: 4554545441111,
        },
      ],
    },
    {
      toPremise: 496,
      cpName: "AKBARPUR",
      packets: [
        {
          status: "HUB-IN-SCANNED",
          awbNumber: 22222222323,
        },
      ],
      shipments: [
        {
          status: "OUSCAN",
          awbNumber: 4554545443232,
        },
      ],
    },
  ];

  const getTableData = async () => {
    setLoading(true);
    let response = await API.Api(GET_CP_WISE_SORTING_DATA).getWithAllHeaders();
    if (response.status) {
      let updateData = response?.response?.data.map((val) => {
        val["allShipments"] = [...val.packets, ...val.shipments].sort(function (
          a,
          b
        ) {
          return a.status !== "HUB-IN-SCANNED"
            ? 1
            : b.status !== "HUB-IN-SCANNED"
            ? -1
            : 0;
        });
        delete val.packets;
        delete val.shipments;

        return val;
      });
      setMainData(updateData);
      setLoading(false);
    } else {
      message.error(response.response.data.message || "Network error");
      setLoading(false);
    }
  };

  useEffect(() => {
    let data = JSON.parse(localStorage.getItem("userId"));
    setPremiseName(data?.premises?.premiseName);
  }, []);

  //--Barcode Scanner--//
  let barcode = "";
  let interval;
  const handleKeyDown = (event) => {
    if (interval) clearInterval(interval);
    if (event.code == "Enter") {
      if (barcode) handleStatus(barcode);
      barcode = "";
      return;
    }
    if (event.key != "Shift") barcode += event.key;
    interval = setInterval(() => (barcode = ""), 20);
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    // cleanup this component
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [mainData]);

  const handleStatus = async (barcode) => {
    setLoading(true);

    let filteredArray = mainData.find((element) =>
      element.allShipments.some(
        (subElement) => subElement.awbNumber == +barcode
      )
    );
    let payload = [+barcode];

    let response = await API.Api(
      `${UPDATE_CP_WISE_SORTING_STATUS + filteredArray?.toPremise}`
    ).putIdHeader(payload);
    if (response.status) {
      message.success(barcode + " " + "Shipment Successfully Out-scanned ");
      setLoading(false);
      // getTableData();
    } else {
      message.error(
        response.response.data.message || barcode + " Shipment not found"
      );
      setLoading(false);
    }
  };

  return (
    <Spin spinning={loading}>
      <div className="p-2 in-scan-container sort-to-cp">
        <Heading title="CP Wise Sorting" />
        <div className="master-main-container">
          <div className="align-center space-between">
            <div className="pl-1-5 fw-600"></div>
          </div>
          <div className="content-body">
            {mainData?.length > 0 && (
              <Row justify={"end"}>
                <div>
                  <h4>Number of CPs: {mainData?.length}</h4>
                  <h4>Number of Mini Hubs: 0</h4>
                </div>
              </Row>
            )}

            <Row>
              {mainData?.length > 0 ? (
                mainData?.map((val) => {
                  return (
                    <>
                      <Col
                        className={"sort-to-cp-container"}
                        lg={24}
                        md={24}
                        xs={24}
                        xl={8}
                        sm={24}
                      >
                        <Col span={24} className="card">
                          <Row>
                            <Col span={12}>
                              <div className="title d-flex">
                                <span className="sub-title">CP Name: </span>
                              </div>
                            </Col>
                            <Col span={12}>
                              <div
                                className="title d-flex"
                                style={{ height: "35px" }}
                              >
                                <span>
                                  {" "}
                                  {capitaliseWithHyphen(val?.cpName)}
                                </span>
                              </div>
                            </Col>
                          </Row>

                          <Row>
                            <Col span={12}>
                              <div className="title d-flex">
                                <span className="sub-title">HUB Name: </span>
                              </div>
                            </Col>
                            <Col span={12}>
                              <div className="title d-flex">
                                <span> {capitalize(premiseName)}</span>
                              </div>
                            </Col>
                          </Row>

                          <Row>
                            <Col span={12}>
                              <div className="title d-flex">
                                <span className="sub-title">
                                  No of Shipments:
                                </span>
                              </div>
                            </Col>
                            <Col span={12}>
                              <div className="title d-flex">
                                <span>{val?.allShipments?.length}</span>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col span={12}>
                              <div className="title d-flex">
                                <span className="sub-title">
                                  No of Packets:
                                </span>
                              </div>
                            </Col>
                            <Col span={12}>
                              <div className="title d-flex">
                                <span>{val?.packets?.length || 0}</span>
                              </div>
                            </Col>
                          </Row>
                          <hr className="divider" />
                          <div className="title list-container">
                            <span className="sub-title">Shipments List: </span>
                            <Row
                              className="mt-1 barcode-list"
                              justify={"space-between"}
                            >
                              {val?.allShipments?.map((val, i) => {
                                return (
                                  <Col
                                    span={10}
                                    key={i}
                                    style={{
                                      background: "white",
                                      padding: "6px",
                                      margin: "5px 2px",
                                      minWidth: "160px",
                                      height: "fit-content",
                                      whiteSpace: "nowrap",
                                      border: "1px solid #EAE0C0",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <span>{val.awbNumber}</span>

                                      <span>
                                        {val.status !== "HUB-IN-SCANNED" ? (
                                          <Scan_check />
                                        ) : null}
                                      </span>
                                    </div>
                                  </Col>
                                );
                              })}
                            </Row>
                            <Row className="d-flex mt-1">
                              <Col span={24}>
                                <Input
                                  placeholder="Enter barcode to out-scan"
                                  bordered
                                  onChange={(e) => {
                                    if (e.target.value.length > 6) {
                                      handleStatus(+e.target.value);
                                    }
                                  }}
                                  style={{
                                    borderRadius: "5px",
                                    height: "40px",
                                    // width: "400px",
                                  }}
                                />
                              </Col>
                              {/* <Col span={2}></Col> */}
                              {/* <Col span={4}>
                                <Button
                                  className="save-btn "
                                  onClick={() => console.log("hello")}
                                  disabled={check ? false : true}
                                >
                                  DONE
                                </Button>
                              </Col> */}
                            </Row>
                          </div>
                        </Col>
                      </Col>
                    </>
                  );
                })
              ) : (
                <Col span={24}>
                  <Empty />
                </Col>
              )}
            </Row>
          </div>
        </div>

        <div className="d-flex flex-end mt-1">
          <Button
            className="cancel-btn mr-1"
            style={{ textAlign: "end" }}
            onClick={() => navigate("/hub-in-scan")}
          >
            DONE
          </Button>
        </div>
      </div>
    </Spin>
  );
};

export default InScanTable;

//
